import React from "react";
import PropTypes from "prop-types";
import { orientation, sortRouteNo } from "../../util/tools";

const SearchResult = ({
  handlePlatformSelect,
  PlatformName,
  Bearing,
  PlatformNo,
  PlatformTag,
  RouteNos
}) => {
  const handleEnter = e => {
    if (e.key === "Enter") {
      handlePlatformSelect(PlatformTag, PlatformNo, PlatformName, RouteNos);
      e.preventDefault();
    }
  };

  return (
    <li className="list__item">
      <div
        title="Click to view buses due at this stop"
        onClick={() =>
          handlePlatformSelect(PlatformTag, PlatformNo, PlatformName, RouteNos)
        }
        role="button"
        onKeyPress={e => handleEnter(e)}
        tabIndex={0}
      >
        <div>
          {PlatformName} {Bearing && `(buses going ${orientation(Bearing)})`}
        </div>
        <div>
          {PlatformNo
            ? `Stop no. ${PlatformNo}, buses from this stop: `
            : `Buses from this stop: `}
          {sortRouteNo(RouteNos)}
        </div>
      </div>
    </li>
  );
};

SearchResult.defaultProps = {
  PlatformName: "",
  Bearing: null,
  PlatformNo: 0,
  PlatformTag: null,
  RouteNos: ""
};

SearchResult.propTypes = {
  handlePlatformSelect: PropTypes.func.isRequired,
  PlatformName: PropTypes.string,
  Bearing: PropTypes.number,
  PlatformNo: PropTypes.number,
  PlatformTag: PropTypes.number,
  RouteNos: PropTypes.string
};

export default SearchResult;
